import { EndInstructionProvider } from '@context/EndInstruction';
import EndInstructionView from './EndInstructionView';

const EndInstruction = () => {
  return (
    <EndInstructionProvider>
      <EndInstructionView />
    </EndInstructionProvider>
  );
};

export default EndInstruction;
